angular.
module("dx.webapp.api").
factory("dxApiV1Mastertools", function apiV1Mastertools(
	$http
) {
	"use strict";

	function duplicatesPost(duplicateUsers) {
		return $http.post("/api/v1/mastertools/duplicates", duplicateUsers);
	}

	return {
		duplicates: {
			post: duplicatesPost,
		},
	};
});
